import { render, staticRenderFns } from "./NewList3.vue?vue&type=template&id=4e6d776e&scoped=true&"
import script from "./NewList3.vue?vue&type=script&lang=js&"
export * from "./NewList3.vue?vue&type=script&lang=js&"
import style0 from "./NewList3.vue?vue&type=style&index=0&id=4e6d776e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6d776e",
  null
  
)

export default component.exports